__turbopack_context__.v({
  "blog-header-text-container": "FeaturedPosts-module-scss-module__hhDh8a__blog-header-text-container",
  "featured-article": "FeaturedPosts-module-scss-module__hhDh8a__featured-article",
  "featured-article-grid": "FeaturedPosts-module-scss-module__hhDh8a__featured-article-grid",
  "featured-image-container": "FeaturedPosts-module-scss-module__hhDh8a__featured-image-container",
  "featured-post-title": "FeaturedPosts-module-scss-module__hhDh8a__featured-post-title",
});
